import { BASE_GAIL } from "./baseUrls";

export const EUROPE_REGION = "europe";
export const GLOBAL_REGION = "global";

export type GailRegion = typeof EUROPE_REGION | typeof GLOBAL_REGION;

/**
 * HTML `region` value for `@gail-ai/conversation-embed`.
 * Distinct from {@link GailRegion} (`"europe"`): the web component expects `"eu"`.
 * Omit the attribute for global — never write `region="global"` or `region="europe"`.
 */
export const CONVERSATION_EMBED_EU_REGION = "eu";

export type ConversationEmbedRegion =
  | typeof GLOBAL_REGION
  | typeof CONVERSATION_EMBED_EU_REGION;

export function getConversationEmbedRegionAttr(
  region: string | undefined = process.env.NEXT_PUBLIC_REGION
): typeof CONVERSATION_EMBED_EU_REGION | undefined {
  return isEuropeRegion(region) ? CONVERSATION_EMBED_EU_REGION : undefined;
}

function addEuropeHostnameSegment(hostname: string): string {
  const segments = hostname.split(".");
  if (segments.includes("eu")) return hostname;

  segments.splice(1, 0, "eu");
  return segments.join(".");
}

function removeEuropeHostnameSegment(hostname: string): string {
  return hostname
    .split(".")
    .filter((segment) => segment !== "eu")
    .join(".");
}

export function isEuropeRegion(
  region: string | undefined = process.env.NEXT_PUBLIC_REGION
): boolean {
  return region === EUROPE_REGION;
}

export function canUseAbly(
  region: string | undefined = process.env.NEXT_PUBLIC_REGION
): boolean {
  return !isEuropeRegion(region);
}

export function getOppositeRegion(
  region: string | undefined = process.env.NEXT_PUBLIC_REGION
): GailRegion {
  return isEuropeRegion(region) ? GLOBAL_REGION : EUROPE_REGION;
}

export function getOppositeRegionBaseUrl(
  baseUrl: string | undefined = BASE_GAIL,
  region: string | undefined = process.env.NEXT_PUBLIC_REGION
): string {
  if (!baseUrl) return "";

  try {
    const url = new URL(baseUrl);
    url.hostname =
      getOppositeRegion(region) === EUROPE_REGION
        ? addEuropeHostnameSegment(url.hostname)
        : removeEuropeHostnameSegment(url.hostname);

    return url.toString();
  } catch {
    return baseUrl;
  }
}
